import { useHydrateStorageZaps } from "./useHydrateStorageZaps";
import { useQueryPausedZaps } from "./useQueryPausedZaps";
import { StorageZap } from "./useQueryStorageZaps";

interface usePausedZapsInput {
  enabled?: boolean;
}

export function usePausedZaps({ enabled = true }: usePausedZapsInput) {
  const {
    response: zapsResponse,
    isLoading,
    isFetching,
  } = useQueryPausedZaps({ enabled });

  const storageZaps =
    (zapsResponse?.results as StorageZap[]) || ([] as StorageZap[]);

  const { list: hydratedZaps } = useHydrateStorageZaps(storageZaps);

  const organizationZaps = {
    zaps: hydratedZaps,
    meta: zapsResponse?.meta || { count: 0, offset: 0, limit: 0 },
  };

  return {
    isFetching,
    isLoading,
    meta: organizationZaps.meta,
    totalPages: 1,
    zaps: organizationZaps?.zaps || [],
  };
}
